/**
 * Pentavite — member-gift login prompt (guests only).
 *
 * v6 adds the checkout moment: a signed-out shopper whose cart has unlocked the
 * RM80 gift gets asked one last time when they press “Check out”. The navigation
 * is held so they can choose — log in and keep the gift, or continue without it
 * (the second button turns into “Continue to checkout”).
 *
 * Carried over from v4/v5:
 *   - mounts on the cart page *and* in the cart drawer (drawer content is copied
 *     into the page, so its own <script> never runs — the file is loaded globally
 *     from layout/theme.liquid instead, guarded so it runs once);
 *   - the overlay is moved to <body> so the drawer's transform cannot clip it;
 *   - asks again each time the drawer is re-opened, once per cart-page visit, and
 *     once more when the cart crosses RM80;
 *   - members never see it (the element only exists for signed-out shoppers).
 */
(function () {
  if (window.__pvGiftLoginPromptLoaded) return;
  window.__pvGiftLoginPromptLoaded = true;

  var CHECKOUT = '#checkout-submit, button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkout?"], [data-pv-checkout]';
  var CHECKOUT_LABEL = 'Continue to checkout';

  var dismissed = false;
  var wasVisible = false;
  var adopted = false;
  var busy = false;
  var checkoutHold = false;   // the modal was opened by the Check out button
  var bypass = false;         // shopper chose to continue without the gift

  function roots() {
    return [].slice.call(document.querySelectorAll('[data-pv-giftlogin]'));
  }

  function onCartPage() {
    return window.location.pathname.indexOf('/cart') === 0;
  }

  function visible(el) {
    if (!el) return false;
    if (onCartPage()) return true;
    try {
      return el.getClientRects().length > 0;
    } catch (error) {
      return false;
    }
  }

  function primary() {
    var all = roots();
    if (!all.length) return null;
    for (var i = 1; i < all.length; i++) {
      var extra = all[i].querySelector('[data-pv-giftlogin-modal]');
      if (extra && extra.parentNode) extra.parentNode.removeChild(extra);
    }
    return all[0];
  }

  function values() {
    var el = primary();
    if (!el) return null;
    return {
      el: el,
      threshold: parseInt(el.getAttribute('data-threshold'), 10) || 0,
      total: parseInt(el.getAttribute('data-cart-total'), 10) || 0
    };
  }

  function qualifies(v) {
    return !!v && v.threshold > 0 && v.total >= v.threshold;
  }

  function modal() {
    var el = document.querySelector('[data-pv-giftlogin-modal]');
    if (!el) return null;
    if (!adopted && el.parentNode !== document.body) {
      document.body.appendChild(el);   // out of the drawer's clipping/transform
      adopted = true;
    }
    return el;
  }

  function laterButton() {
    return document.querySelector('.pv-giftlogin__later');
  }

  function sync() {
    var v = values();
    if (!v) return;
    var shown = visible(v.el);
    if (shown && !wasVisible) {
      dismissed = false;
      checkoutHold = false;
    }
    wasVisible = shown;
    var el = modal();
    if (!el) return;
    if (!shown) {
      el.hidden = true;
      return;
    }
    var open = qualifies(v) && (!dismissed || checkoutHold);
    el.hidden = !open;
    var later = laterButton();
    if (later) {
      later.textContent = checkoutHold ? CHECKOUT_LABEL : 'Not now';
    }
  }

  function close() {
    var later = laterButton();
    var wasHold = checkoutHold;
    dismissed = true;
    checkoutHold = false;
    var el = modal();
    if (el) el.hidden = true;
    if (later) later.textContent = 'Not now';
    if (wasHold) {
      bypass = true;                       // they chose the cart over the gift
      window.location.href = '/checkout';
    }
  }

  // Hold the checkout press once, so the prompt can be shown.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('a[href*="customer_authentication"], a[href*="/account/login"]')) {
      try { document.cookie = 'pvGiftLoginIntent=1; path=/; max-age=1800'; } catch (error) {}
    }
    if (target.closest('[data-pv-giftlogin-close]')) {
      event.preventDefault();
      close();
      return;
    }
    if (bypass) return;
    var v = values();
    if (!qualifies(v)) return;             // nothing to lose if the gift isn't unlocked
    if (!target.closest(CHECKOUT)) return;
    event.preventDefault();
    event.stopPropagation();
    checkoutHold = true;
    dismissed = false;
    sync();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  function refresh() {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var v = values();
        if (!v) return;
        var before = v.total;
        var now = typeof cart.items_subtotal_price === 'number'
          ? cart.items_subtotal_price
          : cart.total_price;
        v.el.setAttribute('data-cart-total', String(now));
        if (now < v.threshold) {
          dismissed = false;
          checkoutHold = false;
          var el = modal();
          if (el) el.hidden = true;
          return;
        }
        if (before < v.threshold) dismissed = false;
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  document.addEventListener('eurus:cart:items-changed', refresh);
  window.addEventListener('focus', refresh);

  sync();
  window.setInterval(sync, 600);
})();
